import { createApp } from 'vue';
import router from './router';
import store from './store';
import App from './App.vue';
import './css/style.css';
import './assets/fontawesome/css/all.css';
import './assets/themify/themify-icons.css';

const app = createApp(App);

app.use(store);
app.use(router);
app.mount('#app');
